import React, { useState, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  TextField,
  InputAdornment,
  Button,
  IconButton,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  CircularProgress,
  DialogActions,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import AddRoutingProfilePage from "../Adding/addRoute/addroute";
import EditRoutingProfilePage from "../Editing/editRoute/editroute";
import { endpoints } from "../../services/endpoint"; 
import { axiosInstance } from "../../services/axiosInstance"; // Importing named exportadjust path as needed
const RoutingProfilePage = ({ data ,nextToken}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [showAddForm, setShowAddForm] = useState(false);
  const [routingProfiles, setRoutingProfiles] = useState(data || []);
  const [editingProfile, setEditingProfile] = useState(null);
const [actionClicked, setActionClicked] = useState(null); // "yes" | "no" | null
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [profileToDelete, setProfileToDelete] = useState(null);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const email = localStorage.getItem("Email");
   const username = localStorage.getItem("username")

  const instanceAlias = localStorage.getItem("instanceName");
  const instanceId = localStorage.getItem("InstanceId");
  const customerAWSAccountId = localStorage.getItem("CustomerAWSAccountId");
  const region = localStorage.getItem("Region");
     const EncryptedInstanceId=localStorage.getItem("EncryptedId")
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredData = useMemo(() => {
    if (!searchQuery.trim()) return routingProfiles;
    const query = searchQuery.toLowerCase();
    return routingProfiles.filter(
      (profile) =>
        profile.name?.toLowerCase().includes(query) ||
        profile.description?.toLowerCase().includes(query) ||
        profile.numberOfAssociatedQueues?.toString().includes(query) ||
        profile.numberOfAssociatedUsers?.toString().includes(query) ||
        JSON.stringify(profile.tags)?.toLowerCase().includes(query)
    );
  }, [routingProfiles, searchQuery]);

  const handleProfileAdded = (updatedList) => {
    setRoutingProfiles(updatedList || []);
    setShowAddForm(false);
  };

  const handleProfileUpdated = (updatedList) => {
    setRoutingProfiles(updatedList || []);
    setEditingProfile(null);
  };

  // const handleDeleteClick = (index) => {
  //   setProfileToDelete(routingProfiles[index]);
  //   setDeleteIndex(index);
  //   setDeleteDialogOpen(true);
  // };
  const handleDeleteClick = (index) => {
  setProfileToDelete(routingProfiles[index]);
  setDeleteIndex(index);
  setDeleteDialogOpen(true);
};

  const [deletingProfileName, setDeletingProfileName] = useState(null);
const [loading, setLoading] = useState(false);
  // const handleConfirmDelete = async () => {
  //   setLoading(true);
  //   try {
      

  //     const requestPayload = {
  //       action: "delete",
  //      ID:EncryptedInstanceId,
  //      routing_profile_name: profileToDelete?.name, // ✅ This is correct
  //       InstanceAlias:instanceAlias,
  //       confirmation: "yes",
  //       Email:email,
  //     UserName:username,
  //       region,
  //       awsAccount:customerAWSAccountId,
  //     };

  //     const response = await axiosInstance.post(
  //        endpoints.addRoute.newRoute, // 🟢 use appropriate endpoint for deleting routing profiles
  //       requestPayload
  //     );

  //     if (response.status === 200) {
  //       const updated = routingProfiles.filter((_, i) => i !== deleteIndex);
  //       setRoutingProfiles(updated);
  //       setDeleteDialogOpen(false);
  //       setProfileToDelete(null);
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("Failed to delete routing profile:", error);
  //   }
  // };
const handleConfirmDelete = async () => {
  if (!profileToDelete) return;

  setDeletingProfileName(profileToDelete.name); // mark this row
  setLoading(true);

  try {
    const requestPayload = {
      action: "delete",
      ID: EncryptedInstanceId,
      routing_profile_name: profileToDelete.name,
      InstanceAlias: instanceAlias,
      confirmation: "yes",
      Email: email,
      UserName: username,
      region,
      awsAccount: customerAWSAccountId,
    };

    const response = await axiosInstance.post(
      endpoints.addRoute.newRoute,
      requestPayload
    );

    if (response.status === 200) {
      const updated = routingProfiles.filter((_, i) => i !== deleteIndex);
      setRoutingProfiles(updated);
      setDeleteDialogOpen(false);
      setProfileToDelete(null);
    }
  } catch (error) {
    console.error("Failed to delete routing profile:", error);
  } finally {
    setDeletingProfileName(null); // reset row spinner
    setLoading(false);            // reset dialog button
  }
};

  if (showAddForm) {
    return (
      <AddRoutingProfilePage
        onClose={() => setShowAddForm(false)}
        onProfileAdded={handleProfileAdded}
        instanceAlias={instanceAlias}
        instanceId={instanceId}
        customerAWSAccountId={customerAWSAccountId}
        region={region}
      />
    );
  }

  if (editingProfile) {
    return (
      <EditRoutingProfilePage
        profile={editingProfile}
        onClose={() => setEditingProfile(null)}
        onUpdate={handleProfileUpdated}
      />
    );
  }

  return (
  <Box p={3}>
    <Typography variant="h6" className="phone-number-title">
               Routing Profiles list
             </Typography>
   <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} mt={1}gap={2}>
  <TextField
    placeholder="Search..."
    value={searchQuery}
    className="search-textfield"
  
    onChange={handleSearchChange}
  
    
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <SearchIcon />
        </InputAdornment>
      ),
    }}
  />

  <Button
    variant="contained"
    startIcon={<AddIcon />}
    className="routing-button"
    onClick={() => setShowAddForm(true)}
  >
    Add Routing Profile
  </Button>
</Box>

      <TableContainer component={Paper}>
        
       
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Associated Queues</TableCell>
              <TableCell>Agents Staffed</TableCell>
              <TableCell>Tags</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredData.map((profile, index) => (
              <TableRow key={index}>
                <TableCell>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setEditingProfile(profile);
                    }}
                    style={{
                      textDecoration: "underline",
                      color: "#1976d2",
                      cursor: "pointer",
                    }}
                  >
                    {profile.name}
                  </a>
                </TableCell>

                <TableCell>{profile.description || "-"}</TableCell>
                <TableCell>{profile.numberOfAssociatedQueues || "-"}</TableCell>
                <TableCell>{profile.numberOfAssociatedUsers || "-"}</TableCell>
           <TableCell>
  {profile.tags && profile.tags !== "No tags" ? (
    profile.tags.split(",").map((tag, idx) => (
      <Chip
        key={idx}
        label={tag.trim()}
        size="small"
        sx={{ m: 0.3 }}
      />
    ))
  ) : (
    <Typography variant="body2" color="textSecondary">
      No tags
    </Typography>
  )}
</TableCell>




               <TableCell align="center">
  <IconButton
    color="error"
    onClick={() => handleDeleteClick(index)}
    disabled={deletingProfileName === routingProfiles[index]?.name}
  >
    {deletingProfileName === routingProfiles[index]?.name ? (
      <CircularProgress size={18} />
    ) : (
      <DeleteIcon />
    )}
  </IconButton>
</TableCell>

              </TableRow>
            ))}

            {filteredData.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No matching routing profiles found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
         
      </TableContainer>

   
<Dialog
  open={deleteDialogOpen}
  onClose={() => {
    if (actionClicked !== "delete") {  // prevent closing while deleting
      setDeleteDialogOpen(false);
      setActionClicked(null);
    }
  }}
  disableEscapeKeyDown={actionClicked === "delete"}
>
  <DialogTitle>Confirm Deletion</DialogTitle>
  <DialogContent>
    <DialogContentText>
      Are you sure you want to delete routing profile "
      {profileToDelete?.name}"?
    </DialogContentText>
  </DialogContent>

  <DialogActions>
    {/* Cancel Button */}
    <Button
      variant="outlined"
      color="inherit"
      onClick={() => {
        setActionClicked("cancel");
        setDeleteDialogOpen(false);
        setActionClicked(null); // reset for next time
      }}
       disabled={actionClicked !== null && actionClicked !== "no"}
           sx={{
             opacity: actionClicked === "yes" ? 0.3 : 1,
             minWidth: "80px",
             "&.Mui-disabled": {
               backgroundColor: "#f5f5f5",
               color: "#999",
               borderColor: "#ddd"
             }
           }}
         >
           {actionClicked === "no" ? <CircularProgress size={18} /> : "No"}
         </Button>
    {/* Delete Button */}
    <Button
      color="error"
      variant="contained"
      onClick={async () => {
        setActionClicked("delete");
        await handleConfirmDelete();
        setDeleteDialogOpen(false);
        setActionClicked(null); // reset after completion
      }}
     disabled={actionClicked !== null && actionClicked !== "yes"}
          startIcon={
            actionClicked === "yes" ? <CircularProgress size={18} color="inherit" /> : null
          }
          sx={{
            opacity: actionClicked === "yes" ? 0.7 : 1,
            minWidth: "120px",
            "&.Mui-disabled": {
              backgroundColor: "#ffebee",
              color: "#f44336"
            }
          }}
        >
          {actionClicked === "yes" ? "Deleting..." : "Yes, Delete"}
        </Button>
  </DialogActions>
</Dialog>

    </Box>
  );
};

export default RoutingProfilePage;
